// src/features/equipment/pages/EquipmentDetailsPage/components/EquipmentMetadataCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Stack,
} from '@mui/material';
import { InfoOutline as InfoIcon } from '@mui/icons-material';
import StaffMemberById from '../../../../../components/common/StaffMemberById';
import LocalizedDateDistance from '../../../../../i18n/LocalizedDateDistance';
import SectionHeader from '../../../../../components/common/SectionHeader';

export default function EquipmentMetadataCard({ equipment }) {
  const { t } = useTranslation(['equipment', 'common']);

  return (
    <Box>
      <SectionHeader icon={InfoIcon} title={t('equipment:metadata')} />
      <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('equipment:labels.added')}
            </Typography>
            <Typography variant="body2">
              <LocalizedDateDistance date={equipment.created_at} />
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('equipment:labels.added_by')}
            </Typography>
            <StaffMemberById staffId={equipment.added_by} />
          </Box>

          {!equipment.is_active && (
            <>
              <Box>
                <Typography variant="caption" color="text.secondary">
                  {t('equipment:labels.deactivated_by')}
                </Typography>
                <StaffMemberById staffId={equipment.deactivated_by} />
              </Box>

              {equipment.deactivation_reason && (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {t('equipment:labels.deactivation_reason')}
                  </Typography>
                  <Typography variant="body2">
                    {equipment.deactivation_reason}
                  </Typography>
                </Box>
              )}

              {equipment.deactivated_at && (
                <Box>
                  <Typography variant="caption" color="text.secondary">
                    {t('common:labels.deactivated_at')}
                  </Typography>
                  <Typography variant="body2">
                    <LocalizedDateDistance date={equipment.deactivated_at} />
                  </Typography>
                </Box>
              )}
            </>
          )}
      </Stack>
    </Box>
  );
}